import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Popconfirm } from 'antd';
import {
  DollarCircleOutlined,
  LogoutOutlined,
  UserOutlined,
  BankOutlined,
  FileAddOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  SolutionOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  RightOutlined,
  AuditOutlined,
  ContainerOutlined,
  HomeOutlined,
  ShopOutlined,
  NodeIndexOutlined,
} from '@ant-design/icons';
import './style.css';
import logo from '../../assets/images/sp-finance-logo-2.png';

function SideBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [openGroups, setOpenGroups] = useState({});

  const logout = () => {
    localStorage.setItem('access_id', '');
    localStorage.setItem('user_role', '');
    localStorage.setItem('user_name', '');
    localStorage.setItem('selectedMonth', '');
    navigate('/');
    window.location.reload();
  };

  const menuItems = [
    {
      path: '/',
      label: 'Dashboard',
      icon: DashboardOutlined,
    },
    {
      label: 'Collection',
      icon: BankOutlined,
      children: [
        {
          path: '/collection-summary',
          label: 'Verification',
          extraPaths: ['/collection-verification'],
          icon: CheckCircleOutlined,
        },
        {
          path: '/subscriptionLogs',
          label: 'Edit Logs',
          icon: FileTextOutlined,
        },
      ],
    },
    {
      path: '/phonepe',
      label: 'Phone Pe Entries',
      icon: DollarCircleOutlined,
      extraPaths: ['/phonepe-list'],
    },
    {
      path: '/razorpay',
      label: 'Razorpay Entries',
      icon: DollarCircleOutlined,
      extraPaths: ['/razorpay-collection'],
    },
    {
      path: '/revenue',
      label: 'Revenue',
      icon: DollarCircleOutlined,
    },
    {
      label: 'Tax',
      icon: AuditOutlined,
      extraPaths: ['/gst/invoices', '/gst/b2b-invoices', '/gst/franchise-invoices'],
      children: [
        {
          path: '/gst/summary',
          label: 'Full Ops',
          icon: HomeOutlined,
        },
        {
          path: '/gst/franchise-invoices',
          label: 'Franchise',
          icon: ShopOutlined,
        },
        {
          path: '/gst/b2b-invoices',
          label: 'B2B',
          icon: NodeIndexOutlined,
        },
      ],
    },
    // {
    //   path: '/assets/manage',
    //   label: 'Assets',
    //   icon: ContainerOutlined,
    // },
  ];

  return (
    <nav className="sidebar">
      <div className="sidebar-container">
        <div className="sidebar-logo-container">
          <img className="sidebar-logo" src={logo} alt="logo" />
        </div>

        <div className="sidebar-container">
          <div className="sidebar-menu-container">
            <div className="sidebar-items">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const hasChildren = item.children && item.children.length;

                const isParentActive = hasChildren
                  ? item.children.some(
                      (child) =>
                        location.pathname === child.path ||
                        (child.extraPaths &&
                          child.extraPaths.some((p) => location.pathname.includes(p))),
                    )
                  : false;

                const isActive =
                  location.pathname === item.path ||
                  (item.extraPaths && item.extraPaths.some((p) => location.pathname.includes(p))) ||
                  isParentActive;

                const open = openGroups[item.label] ?? isParentActive;

                return (
                  <div key={item.label}>
                    {hasChildren ? (
                      <div
                        className="menu-option"
                        data-active={isActive}
                        onClick={() => {
                          setOpenGroups((prev) => ({ [item.label]: true }));
                          if (item.children && item.children[0] && item.children[0].path) {
                            navigate(item.children[0].path);
                          }
                        }}
                      >
                        {Icon && (
                          <Icon
                            className={`sidebar-icon ${isActive ? 'sidebar-icon-active' : ''}`}
                          />
                        )}
                        <div className="menu-label" data-active={isActive}>
                          {item.label}
                        </div>
                        <RightOutlined
                          className={`sidebar-arrow ${open ? 'sidebar-arrow-open' : ''}`}
                          data-active={isActive}
                        />
                      </div>
                    ) : (
                      <Link to={item.path} key={item.path} onClick={() => setOpenGroups({})}>
                        <div className="menu-option" data-active={isActive}>
                          {Icon && (
                            <Icon
                              className={`sidebar-icon ${isActive ? 'sidebar-icon-active' : ''}`}
                            />
                          )}
                          <div className="menu-label" data-active={isActive}>
                            {item.label}
                          </div>
                        </div>
                      </Link>
                    )}

                    {hasChildren &&
                      open &&
                      item.children.map((child) => {
                        const ChildIcon = child.icon;
                        const isActiveChild =
                          location.pathname === child.path ||
                          (child.extraPaths &&
                            child.extraPaths.some((p) => location.pathname.includes(p)));

                        return (
                          <Link to={child.path} key={child.path}>
                            <div
                              className="menu-option"
                              data-active={isActiveChild}
                              data-sub-menu="true"
                            >
                              {ChildIcon && (
                                <ChildIcon
                                  className={`sidebar-icon ${isActiveChild ? 'sidebar-icon-active' : ''}`}
                                />
                              )}
                              <div className="menu-label" data-active={isActiveChild}>
                                {child.label}
                              </div>
                            </div>
                          </Link>
                        );
                      })}
                  </div>
                );
              })}
            </div>
          </div>

          <Popconfirm
            title="Are you sure to logout?"
            onConfirm={logout}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <div className="sidebar-footer">
              <span className="sidebar-footer-label">
                <UserOutlined />
                <span className="sidebar-username"> {localStorage.getItem('user_name')} </span>
              </span>
              <LogoutOutlined className="sidebar-item-icon" />
            </div>
          </Popconfirm>
        </div>
      </div>
    </nav>
  );
}

export default SideBar;
